<template>
  <div>
    <section class="member-box">
      <div class="container">
        <div class="box">
          <h1>{{ $t("忘記密碼") }}</h1>
          <hr />
          <div class="form-group phone-box" style="position: relative">
            <label for="phone">{{ $t("手機號碼") }}</label>
            <div class="phone">
              <vue-tel-input v-bind="vtiProps" @input="onInput"></vue-tel-input>
            </div>
            <span id="showPhone" @click="viewphone = !viewphone"><img
                :src="viewphone ? 'img/eyes-n.png' : 'img/eyes-y.png'" style="width: auto; height: 16px" /></span>
          </div>
          <div class="btn-box" v-if="!issned">
            <button class="code-btn" @click="getPinCode">
              {{ $t("獲取驗證碼") }}
            </button>
          </div>
          <div class="form-group" v-if="issned">
            <label for="pincode_input">{{ $t("手機驗證碼") }}</label>
            <input :placeholder="$t('請輸入手機簡訊驗證碼')" type="text" class="form-control" id="pincode_input"
              v-model="pincode_input" @input="pincode_input_onInput" />
          </div>

          <div class="form-group" v-if="pincodeCheck">
            <label for="password">{{ $t("重設密碼") }}</label>
            <input :placeholder="$t('請輸入您想重新設定的密碼')" :type="viewpassword ? 'text' : 'password'" class="form-control"
              id="password" v-model="password" />
          </div>
          <div class="form-group" v-if="pincodeCheck">
            <label for="passwordConfirm">{{ $t("確認密碼") }}</label>
            <input :placeholder="$t('請再次輸入您想重新設定的密碼')" :type="viewpasswordConfirm ? 'text' : 'password'"
              class="form-control" id="passwordConfirm" v-model="passwordConfirm" />
          </div>

          <button v-if="pincodeCheck" @click="handleForget">
            {{ $t("送出") }}
          </button>
          <!-- 0518 增加 連結 -->
          <router-link :to="{ name: 'Login' }" class="note mt-3" v-if="!issned">{{ $t("返回登入") }}</router-link>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueTelInput, {
  autoDefaultCountry: true,
  defaultCountry: 886,
  dropdownOptions: {
    showDialCodeInSelection: true,
  },
  inputOptions: {
    placeholder: "",
  },
});
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "忘記密碼": "忘記密碼",
    "手機號碼": "手機號碼",
    "獲取驗證碼": "獲取驗證碼",
    "手機驗證碼": "手機驗證碼",
    "請輸入手機簡訊驗證碼": "請輸入手機簡訊驗證碼",
    "重設密碼": "重設密碼",
    "請輸入您想重新設定的密碼": "請輸入您想重新設定的密碼",
    "確認密碼": "確認密碼",
    "請再次輸入您想重新設定的密碼": "請再次輸入您想重新設定的密碼",
    "錯誤": "錯誤",
    "手機號碼格式錯誤": "手機號碼格式錯誤",
    "確定": "確定",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "重設密碼與確認重設密碼不符合, 請確認後再試一次",
    "密碼修改成功": "密碼修改成功",
    "即將前往登入頁面": "即將前往登入頁面",
  },
  en: {
    "忘記密碼": "Forgot the password?",
    "手機號碼": "Mobile number",
    "獲取驗證碼": "Get the verification code",
    "手機驗證碼": "Verification code via mobile",
    "請輸入手機簡訊驗證碼": "Please enter the verification code",
    "重設密碼": "Reset password",
    "請輸入您想重新設定的密碼": "Please enter the password you want to reset",
    "確認密碼": "Confirm password",
    "請再次輸入您想重新設定的密碼": "Please enter the password you want to reset again",
    "錯誤": "Error",
    "手機號碼格式錯誤": "Wrong format of mobile number",
    "確定": "Confirm",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "Please confirm the new password and try again.",
    "密碼修改成功": "Password changed",
    "即將前往登入頁面": "Will return to the login page",
  },
  jp: {
    "忘記密碼": "パスワード",
    "手機號碼": "電話番号",
    "獲取驗證碼": "認証コードを受け取る",
    "手機驗證碼": "電話番号認証コード",
    "請輸入手機簡訊驗證碼": "携帯電話のSMS認証コードを入力してください",
    "重設密碼": "パスワードを再設定する",
    "請輸入您想重新設定的密碼": "リセットしたいパスワードを入力してください",
    "確認密碼": "パスワード確認",
    "請再次輸入您想重新設定的密碼": "リセットしたいパスワードを再入力してください",
    "錯誤": "エラー",
    "手機號碼格式錯誤": "電話番号の形式が正しくありません",
    "確定": "確定",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次": "新しいパスワードと新しいパスワード(確認用)が一致しません,ご確認の上、再度お試しください",
    "密碼修改成功": "パスワードを変更しました",
    "即將前往登入頁面": "ログイン画面に戻ってください",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Forget",
  i18n,
  data() {
    return {
      countryCallingCode: "",
      number: "",
      valid: false,
      issned: false,
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      password: "",
      passwordConfirm: "",
      vtiProps: {
        disabled: false,
      },
      viewpassword: false,
      viewpasswordConfirm: false,
      viewphone: false,
    };
  },
  watch: {
    viewphone(newValue, oldValue) {
      if (newValue) {
        $(".vti__input").addClass("show_phone");
      } else {
        $(".vti__input").removeClass("show_phone");
      }
    },
  },
  created: function () { },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member-forget-password");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    onInput(phone, phoneObject, input) {
      this.countryCallingCode = phoneObject.countryCallingCode;
      this.number = phoneObject.number;
      this.valid = phoneObject.valid;
    },
    pincode_input_onInput() {
      if (this.pincode_input == this.pincode) {
        this.pincodeCheck = true;
      } else {
        this.pincodeCheck = false;
      }
    },
    getPinCode() {
      if (!this.valid) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("手機號碼格式錯誤"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        let countryCallingCode =
          this.countryCallingCode == null ? "" : this.countryCallingCode;
        let number = this.number == null ? "" : this.number;
        // 組合並送出
        let token = AES.encrypt(countryCallingCode + "|" + number);
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/ForgetCheckNumber",
          type: "post",
          data: {
            token: token,
          },
          dataType: "json",
          error: function () { },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.vtiProps.disabled = true;
              that.issned = true;
              that.pincode = AES.decrypt(res.PinCode);
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          },
        });
      }
    },
    handleForget() {
      let countryCallingCode =
        this.countryCallingCode == null ? "" : this.countryCallingCode;
      let number = this.number == null ? "" : this.number;
      let password = this.password;
      let passwordConfirm = this.passwordConfirm;
      if (password != passwordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("重設密碼與確認重設密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let token = AES.encrypt(
        countryCallingCode +
        "|" +
        number +
        "|" +
        password +
        "|" +
        passwordConfirm
      );
      let that = this;
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Forget",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("密碼修改成功"),
              text: that.$t("即將前往登入頁面"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                // 轉到首頁
                that.$router.push("/Login");
              },
              allowOutsideClick: false,
            });
          } else if (res.error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: i18n.locale == "en" ? res.error_en : res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.member-box .form-group .phone {
  border: none;
}

.vue-tel-input {
  width: 100%;
}

#showPhone {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Forget.vue